import React from "react";
import withFormFields from "MODULES/shared/decorators/withFormFields";
import * as F from "MODULES/shared/components/Forms/FormTypes";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";
import { WEIGHT, WEIGHT_OZ, WEIGHT_UNIT } from "MODULES/parts/constants";
import { NetWeight } from "MODULES/parts/components/shared/NetWeight";

export function NetInvoiceWeight({
  label = "Weight",
  weight,
  weight_oz: weightOz,
  weight_unit: weightUnit
}) {
  return [
    <Col md={3}>
      <NetWeight
        required={false}
        label={label}
        net_weight={weight}
        net_weight_oz={weightOz}
        net_weight_unit={weightUnit}
      />
    </Col>
  ];
}

export default withFormFields(NetInvoiceWeight, [
  WEIGHT,
  WEIGHT_OZ,
  WEIGHT_UNIT
]);

NetInvoiceWeight.propTypes = {
  weight: F.formField(F.malleable).isRequired,
  weight_oz: F.formField(F.malleable).isRequired,
  weight_unit: F.formField(F.stringInput).isRequired,
  required: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/CommercialInvoice/Form/FormSections/NetInvoiceWeight.jsx